import React from 'react';
import PropTypes from 'prop-types';
import { RegionDataResource } from "../../../../resources/js/search/proptypes/region-data-resource";
import classnames from "classnames";

const StatusNavigationBar = props => {
    const {
        browseAllUrl,
        searchCategoryUrl,
        toggleSearchBar,
        regionData,
    } = props

    const renderRegionData = (region, isActive = false) => {
        if (!region) return null;
        const name = region.type ? `${region.type} of ${region.name}` : region.name;
        return (
            <li
                className={classnames("breadcrumb-item", { active: isActive })}
                key={name}
            >
                {!isActive && <a href={region.showRoute}>{name}</a>}
                {isActive && <span>{name}</span>}
            </li>
        );
    }
    const renderCategory = () => {
        if (!regionData.category) return null;
        return (
            <>
                <li className="breadcrumb-item"><a href={searchCategoryUrl}>Category</a></li>
                {renderRegionData(regionData.category, true)}
            </>
        )
    }

    const renderRegion = () => {
        if (regionData.category) return null;
        const activeRegion = regionData.subcounty || regionData.county || regionData.state || regionData.country;
        return (
            <>
                {renderRegionData(regionData.country, regionData.country === activeRegion)}
                {renderRegionData(regionData.state, regionData.state === activeRegion)}
                {renderRegionData(regionData.county, regionData.county === activeRegion)}
                {renderRegionData(regionData.subcounty, regionData.subcounty === activeRegion)}
            </>
        )
    };

    return (
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb bg-dark p-3 mb-0 rounded">
                <li className="breadcrumb-item">
                    <a href={browseAllUrl}><span className="h5"><i className="fas fa-home"></i></span></a>
                </li>
                {renderCategory()}
                {renderRegion()}
                <li className="breadcrumb-item text-primary" onClick={toggleSearchBar}>
                    <i className="fas fa-search"></i>&nbsp;Search
                </li>
            </ol>
        </nav>
    );
};

StatusNavigationBar.propTypes = {
    browseAllUrl: PropTypes.string.isRequired,
    searchCategoryUrl: PropTypes.string.isRequired,
    toggleSearchBar: PropTypes.func.isRequired,
    regionData: PropTypes.shape(RegionDataResource),
};

export default StatusNavigationBar;
